import { render, staticRenderFns } from "./Modal_v2.vue?vue&type=template&id=4faf7b2c"
import script from "./Modal_v2.vue?vue&type=script&lang=js"
export * from "./Modal_v2.vue?vue&type=script&lang=js"
import style0 from "./Modal_v2.vue?vue&type=style&index=0&id=4faf7b2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports